import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/financial/withdrawalRequestsBetShop/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/financial/withdrawalRequestsBetShop/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/financial/withdrawalRequestsBetShop/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/financial/withdrawalRequestsBetShop/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Right panel configuration
        const right = {
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                RecordWithdrawalRequest, // Record withdrawal request component
                DetailsWithdrawalRequest, // Details withdrawal request component
            ],
        };

        // Alternative right panel configuration for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [RecordWithdrawalRequest, DetailsWithdrawalRequest], // Same components as right
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    id: 'select',
                    options: ['10', '20', '50', '100', '1000'], // Page size options
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('table').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('table').refresh(); // Refresh table
                            $$('table').scrollTo(0, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    animate: {
                        subtype: 'out',
                    },
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for localization
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel
                        { id: '2', value: 'Excel Interbank' }, // Export to Interbank Excel
                        { id: '3', value: 'PDF' }, // Export to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('table').getPager().config.size; // Get current page size
                            var page = $$('table').getPage(); // Get current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index

                            // Export to Excel
                            if (value == 1) {
                                var table = $$('table'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel function
                                    filter: function (obj) {
                                        return (
                                            $$('table').getIndexById(obj.id) >= first &&
                                            $$('table').getIndexById(obj.id) <= last
                                        ); // Filter items for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Solicitudes de Retiro', // Filename for export
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                        ch1: true,
                                    },
                                    footer: false,
                                });
                            } else if (value == 2) {
                                // Export to Interbank Excel
                                var table = $$('table'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel function
                                    filter: function (obj) {
                                        return (
                                            $$('table').getIndexById(obj.id) >= first &&
                                            $$('table').getIndexById(obj.id) <= last
                                        ); // Filter items for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Solicitudes de Retiro Interbank', // Filename for export
                                    columns: {
                                        TypeDocument: {
                                            header: _('Tipo de Documento'), // Column header for document type
                                            width: 160,
                                        },
                                        Identification: {
                                            header: _('Número de Documento'), // Column header for document number
                                            width: 160,
                                        },
                                        ClientName: {
                                            header: _('Nombre del Beneficiario'), // Column header for beneficiary name
                                            width: 250,
                                            template: function (obj) {
                                                // Custom template for client name
                                                var array = obj.ClientName.split(' ');
                                                return array[2] + ';' + array[3] + ';' + array[0] + ';' + array[1]; // Rearranged name format
                                            },
                                        },
                                        '': { header: '', width: 200 }, // Empty column
                                        MobilePhone: {
                                            header: _('Celular'), // Column header for mobile phone
                                            width: 200,
                                        },
                                        WayPay: {
                                            header: _('Tipo de Abono'), // Column header for payment type
                                            width: 300,
                                        },
                                        TypeAccount: {
                                            header: _('Tipo de Cuenta'), // Column header for account type
                                            width: 180,
                                        },
                                        Currency: {
                                            header: _('Moneda de Cuenta'), // Column header for account currency
                                            width: 200,
                                        },
                                        AccountBank: {
                                            header: _('N° Cuenta'), // Column header for account number
                                            width: 200,
                                        },
                                        Currency2: {
                                            header: _('Moneda de Abono'), // Column header for payment currency
                                            width: 200,
                                            template: function (obj) {
                                                return obj.Currency; // Return currency value
                                            },
                                        },
                                        Amount: {
                                            header: _('Monto de Abono'), // Column header for payment amount
                                            width: 200,
                                        },
                                    },
                                    footer: false,
                                });
                            } else if (value == 3) {
                                // Export to PDF
                                webix.toPDF($$('table'), {
                                    // Export to PDF function
                                    filter: function (obj) {
                                        return (
                                            $$('table').getIndexById(obj.id) >= first &&
                                            $$('table').getIndexById(obj.id) <= last
                                        ); // Filter items for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Solicitudes de Retiro', // Filename for export
                                    autowidth: true,
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Solicitudes de Retiro') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                FilterWithdrawalRequests, // Filter component
                TableWithdrawalRequest, // Table component
                toolbar, // Toolbar component
            ],
        };

        // Advanced details accordion configuration
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details section
            ],
        };

        // Alternative advanced details accordion for smaller screens
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 200,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height(); // Calculate height for scrolling
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y', // Enable vertical scrolling
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        { id: 'res', view: 'resizer' }, // Resizer between panels
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 for small screens
                            : avanc, // Use avanc for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view after it is created.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen
                $$('res').hide(); // Hide resizer
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown from the toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen
                $$('button-search').hide(); // Hide search button
            }
        });
    }
}

// FILE DOCUMENTED
